module.exports = "<div class=\"page-layout blank p-24 background\" fusePerfectScrollbar>\r\n    <!--<h2>Sample Page</h2>\r\n    <h1>My First Attribute Directive</h1>\r\n<p (pruebaa)=\"holaa\">Highlight me!...</p>-->\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/sample/sample.component.html
// module id = ../../../../../src/app/main/content/sample/sample.component.html
// module chunks = main